import type { AudiencePreviewDto } from 'hooks/useNotification';

const CHANNEL_GAP: Record<string, string> = {
  email: 'no email address',
  sms: 'no verified mobile number',
};

const NAMES_SHOWN = 3;

/**
 * One line per channel that some recipients cannot be reached on, naming the
 * first few.
 */
export function reachabilityWarnings(
  preview:
    | Pick<
        AudiencePreviewDto,
        'unreachableByChannel' | 'unreachableNamesByChannel'
      >
    | null
    | undefined
): string[] {
  if (!preview) return [];
  return Object.entries(preview.unreachableByChannel ?? {})
    .filter(([channel, count]) => count > 0 && channel in CHANNEL_GAP)
    .map(([channel, count]) => {
      const names = preview.unreachableNamesByChannel?.[channel] ?? [];
      const shown = names.slice(0, NAMES_SHOWN).join(', ');
      const more =
        names.length > NAMES_SHOWN
          ? ` and ${names.length - NAMES_SHOWN} more`
          : '';
      const who = shown ? ` (${shown}${more})` : '';
      const people =
        count === 1 ? '1 recipient has' : `${count} recipients have`;
      return `${people} ${CHANNEL_GAP[channel]}${who}, so ${channel === 'sms' ? 'texts' : 'email'} will not reach them. They can add one in their profile.`;
    });
}
